import Structura from './AgencyStructura';

export default Structura;